import { JsonPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Option } from '@interfaces/common/option';
import { SharedModule } from '@src/app/shared/shared.module';

@Component({
  selector: 'app-financial-institution-select-lab',
  standalone: true,
  imports: [SharedModule, FormsModule, ReactiveFormsModule, JsonPipe, NgIf],
  templateUrl: './financial-institution-select-lab.component.html',
  styleUrl: './financial-institution-select-lab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinancialInstitutionSelectLabComponent {
  private readonly destroyRef = inject(DestroyRef);

  mode: 'ngModel-single' | 'ngModel-multi' | 'form-single' | 'form-multi' = 'ngModel-single';
  ngModelSingleValue: string | null = null;
  ngModelMultiValue: string[] = [];

  form: FormGroup;

  logs: string[] = [];
  loadedOptionsCount = 0;

  constructor(private readonly fb: FormBuilder) {
    this.form = this.fb.group({
      single: [null],
      multi: [[]],
    });

    this.form
      .get('single')
      ?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        this.log('form.single.valueChanges', value);
      });

    this.form
      .get('multi')
      ?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        this.log('form.multi.valueChanges', value);
      });
  }

  clearLogs(): void {
    this.logs = [];
  }

  resetStates(): void {
    this.ngModelSingleValue = null;
    this.ngModelMultiValue = [];
    this.form.reset({
      single: null,
      multi: [],
    });
    this.log('action:reset');
  }

  onOptionsLoaded(options: Option[]): void {
    this.loadedOptionsCount = options.length;
    this.log('optionsLoaded', { total: options.length });
  }

  onEvent(event: string, payload?: unknown): void {
    this.log(event, payload);
  }

  setMode(mode: 'ngModel-single' | 'ngModel-multi' | 'form-single' | 'form-multi'): void {
    this.mode = mode;
    this.log('mode', mode);
  }

  private log(event: string, payload?: unknown): void {
    const suffix = payload === undefined ? '' : ` ${JSON.stringify(payload)}`;
    const message = `${event}${suffix}`;
    console.log('[financial-institution-select-lab]', message, payload);
    this.logs = [...this.logs, message];
  }
}
